import { render, staticRenderFns } from "./CatchWordForm.vue?vue&type=template&id=30ca45e1&scoped=true&lang=pug&"
import script from "./CatchWordForm.vue?vue&type=script&lang=js&"
export * from "./CatchWordForm.vue?vue&type=script&lang=js&"
import style0 from "./CatchWordForm.vue?vue&type=style&index=0&id=30ca45e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca45e1",
  null
  
)

export default component.exports